import React from 'react';
import ContactUsComponent from '../../components/about/contact-us';

const ContactUsPage = () => {
    return <ContactUsComponent />
};

export default ContactUsPage;
